var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "div",
        { staticClass: "d-flex align-center" },
        [
          _vm._t(
            "title",
            function () {
              return [
                _vm.isEdit
                  ? _c(
                      "a",
                      {
                        directives: [
                          {
                            name: "b-tooltip",
                            rawName: "v-b-tooltip.hover",
                            modifiers: { hover: true },
                          },
                        ],
                        attrs: { href: "#", title: "Edit location" },
                        on: { click: _vm.showDialog },
                      },
                      [
                        _vm._v(
                          "\n        " +
                            _vm._s(_vm.item.locationNames[0]) +
                            "\n      "
                        ),
                      ]
                    )
                  : _vm.item._id
                  ? _c(
                      "a",
                      {
                        directives: [
                          {
                            name: "b-tooltip",
                            rawName: "v-b-tooltip.hover",
                            modifiers: { hover: true },
                          },
                        ],
                        staticClass: "btn btn-primary mr-2 p-2",
                        attrs: { title: "Edit location" },
                        on: { click: _vm.showDialog },
                      },
                      [_c("i", { staticClass: "far fa-edit fa-fw text-white" })]
                    )
                  : _c(
                      "b-btn",
                      {
                        attrs: { disabled: _vm.disabled, variant: "primary" },
                        on: { click: _vm.showDialog },
                      },
                      [_vm._v("Map")]
                    ),
              ]
            },
            null,
            { showDialog: _vm.showDialog }
          ),
        ],
        2
      ),
      _c(
        "b-modal",
        {
          ref: "container",
          attrs: {
            scrollable: "",
            size: "md",
            title: `${_vm.item._id ? "Edit" : "Add"} location`,
            "hide-footer": "",
            "modal-class": "modal right fade",
            "dialog-class":
              "modal-dialog modal-dialog-slideout modal-dialog-slideout-right modal-dialog-slideout-md p-0",
            "content-class": "no-max-height p-0",
            "body-class": "p-0",
          },
          on: { hidden: _vm.cancel },
        },
        [
          _vm.loading
            ? _c("loading")
            : _vm.show
            ? _c("FormInput", {
                key: _vm.tempItem.updatedAt,
                attrs: {
                  item: _vm.tempItem,
                  supplier: _vm.supplier,
                  pending: _vm.pending,
                  error: _vm.error,
                },
                on: { submit: _vm.submit, cancel: _vm.cancel },
              })
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }